module.exports = "pegasus/assets/theme3/medium/5.jpg";